export enum Payer {
  Customer = "customer",
  Merchant = "merchant",
  Redo = "redo",
}
